'use client';
import React from 'react';
import OurMission from './OurMission';

import styles from '../styles.module.scss';

import {
  FusionSection,
  FusionSectionCaption,
  FusionSectionContent,
  FusionSectionText,
  FusionSectionTitle,
} from '@benzinga/ui';

const HeadingSection = () => {
  return (
    <>
    <FusionSection className={styles.headingSection} sectionPadding>
      <FusionSectionContent className={styles.headingSectionContent} paddingHorizontal={false}>
        <FusionSectionCaption>WHAT IS BENZINGA?</FusionSectionCaption>
        <FusionSectionTitle className={styles.headingSectionTitle}>
          We help you <br /> build wealth
        </FusionSectionTitle>
        <FusionSectionText className={styles.headingSectionText}>
          The financial system can be a daunting environment. Benzinga was designed to help you navigate the challenges
          in personal finance, investing, trading, and much more. We break down complex topics and deliver the most up
          to date information and education you need to become a better investor.
        </FusionSectionText>
        <OurMission />
      </FusionSectionContent>
    </FusionSection>
  </>
  );
};  

export default HeadingSection;
